import { SCREEN_MAX_SIZES } from './variables'

export default () => ({
  screen: SCREEN_MAX_SIZES.phone,
  isMobile: false,
  scrollPosition: 0,
  isCookieAlertVisible: false
})
